import { render, staticRenderFns } from "./commonLeaveStatus.vue?vue&type=template&id=16e295bb&scoped=true"
import script from "./commonLeaveStatus.vue?vue&type=script&lang=js"
export * from "./commonLeaveStatus.vue?vue&type=script&lang=js"
import style0 from "./commonLeaveStatus.vue?vue&type=style&index=0&id=16e295bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e295bb",
  null
  
)

export default component.exports